// @ts-nocheck
import React, { useMemo } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { isFlagOn } from "../../utils/methods/booleanFlag";
import { ExpandMore } from "@mui/icons-material";
import { Box } from "@mui/system";
import { CustomDatePicker } from "../Custom/DatePicker";
import { CustomInput } from "../Custom/Input";
import { AddPhotoAlternate } from "@mui/icons-material";
import ReusableParentContainer from "../Custom/ReusableParentContainer";
import ImageCropper from "../user/ImageCroppper";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import theme from "../../theme";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import {
  acceptReimbursementAction,
  claimReimbursementAction,
  deleteReimbursementCategory,
  fetchReimbursementCategory,
  rejectReimbursementAction,
} from "../../store/actions/eventRequestDetails";
import { Close } from "@mui/icons-material";
import { alertDialogAciton } from "../../store/actions/auth";
import { ReasonModal } from "../../pages/contractor-side/ScheduleTab/tabs/PositionManagementTab";
import {
  fetchContractorLogsAction,
  updateScheduleDataAction,
} from "../../store/actions/contractorScheduleTabActions";
import { useSelector } from "react-redux";
import { addLogAction } from "../../store/actions/logs";
import { Delete } from "@mui/icons-material";
import {
  addReimbursementByAdminAction,
  getAllAdjustmentOfEventAction,
  getDeductionCategoriesAction,
  getReimbursementCategoriesAction,
  removeReimbursementAndDeductionCategoriesAction,
  removeReimbursementOrDeductionAction,
} from "../../store/actions/event/adjustments";
import { CustomIconButton } from "../Custom/CustomIconButton";
import {
  ADJUSTMENT_TYPES,
  getUniversalDateTimeFormat,
} from "../../appCalcutions";
import { isUserRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import InfoHover from "../Tooltip/InfoHover";

export default function DeductionAcc({
  user,
  data,
  expanded,
  handleAccChange,
  eventId,
  setData,
  isEditable,
  status,
  index,
  fetchPO = () => {},
}) {
  const [cropModal, setCropModal] = React.useState(false);
  const [tempImage, setTempImage] = React.useState(null);
  const imageRef = React.useRef(null);
  const [reason, setReason] = React.useState("");
  const [reasonModal, setReasonModal] = React.useState(false);
  const [viewProfileImageFullscreen, setViewProfileImageFullscreen] =
    React.useState({
      status: false,
      image: null,
    });
  const [imageList, setImageList] = React.useState([]);
  const [approveDialog, setApproveDialog] = React.useState(false);
  const [approved, setApproved] = React.useState(0.0);
  const [approvError, setApprovError] = React.useState({
    status: false,
    message: "",
  });
  const { userId, userRole, userName } = useSelector((state) => state.auth);
  const { deductionCategories, arLoading } = useSelector(
    (state) => state?.adjustmentsReducer,
  );

  const isBothPosAndConPresent = useMemo(() => {
    return data?.positionDetails?._id && data?.contractorDetails?._id;
  }, [data]);

  const dispatch = useDispatch();

  function refreshList() {
    dispatch(
      getAllAdjustmentOfEventAction({
        payload: { params: { eventId } },
      }),
    );
    dispatch(getDeductionCategoriesAction({}));
    if (fetchPO) {
      fetchPO();
    }
  }

  const initialValues = {
    deductionCategoryType: "",
    deductionDate:
      data?.positionDetails?.startDate ||
      data?.positionDetails?.positionDate ||
      data?.positionDetails?.positionStartDate
        ? data?.positionDetails?.startDate ||
          data?.positionDetails?.positionDate ||
          data?.positionDetails?.positionStartDate
        : null,
    deductionAmount: 0.0,
    deductionFromClientInvoice: false,
    deductionNotes: "",
    isLinkToContractor: isBothPosAndConPresent ? true : null,
  };

  const validationSchema = Yup.object().shape({
    deductionCategoryType: Yup.string().required(
      "Type of deduction is required",
    ),
    deductionDate: Yup.date().required("Date of Deduction is required"),
    deductionAmount: Yup.number()
      .required("Amount is required")
      .test(
        "minAmount",
        "Amount should be greater than 0",
        (value) => value > 0,
      ),
    deductionFromClientInvoice: Yup.boolean(),
    isLinkToContractor:
      user == "admin" &&
      data?.reImbursementStatus?.toLowerCase() == "draft" &&
      isBothPosAndConPresent
        ? Yup.boolean().nonNullable(
            "Please select where the deduction should linked to",
          )
        : Yup.boolean().nullable(),
    deductionNotes: Yup.string()
      .trim()
      .max(150, "deductionNotes must be less than 150 characters")
      .nullable(true)
      .transform((value, originalValue) =>
        originalValue.trim() === "" ? null : value,
      ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      for (const key in values) {
        formData.append(key, values[key]);
      }
      if (data?.positionDetails?._id) {
        formData.append("positionId", data?.positionDetails?._id);
      }
      formData.append("type", ADJUSTMENT_TYPES.DEDUCTION);
      // formData.append("reImbursementStatus", "Pending");
      // NOTE: do the api call to push it
      // better way to do is create a dispatch action and call it here.
      const details = {
        eventId,
        positionName: data?.positionDetails?.name,
      };

      // if (values?.isLinkToContractor) {
      //   formData?.delete("positionId");
      // }

      formData.append(
        "isReimbursementAttachedToPosition",
        !values?.isLinkToContractor,
      );

      dispatch(
        addReimbursementByAdminAction({
          payload: {
            formData,
            params: {
              // eventid and contractor id here
              eventId,
              contractorId: data?.contractorDetails?._id,
            },
          },
          successCallback: (data) => {
            refreshList();
            dispatch(
              addLogAction({
                id: details?.eventId,
                payload: {
                  actionById: userId,
                  description: `Admin ${userName} created a reimbursement request of $${values?.reImbursementAmount} for ${values?.reImbursementType} under the ${details?.positionName} position.`,
                  positionId: data?.positionDetails?._id,
                },
                successCallback: () => {
                  dispatch(
                    fetchContractorLogsAction({
                      payload: {
                        eventId: details?.eventId,
                      },
                    }),
                  );
                },
              }),
            );
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message:
                  data || "deduction request has been submitted successfully",
              }),
            );
          },
          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: msg || "Failed to submit the deduction request",
              }),
            );
          },
        }),
      );
    },
  });

  const { values, handleChange, touched, errors, handleBlur, submitForm } =
    formik;

  React.useEffect(() => {
    if (data?.newValues) {
      formik.resetForm();
      return;
    }
    if (data?.deductionCategoryType) {
      formik.setFieldValue(
        "deductionCategoryType",
        data?.deductionCategoryType || "",
      );
      formik.setFieldValue("deductionDate", data?.deductionDate || null);
      formik.setFieldValue("deductionAmount", data?.deductionAmount || 0);
      formik.setFieldValue("deductionNotes", data?.deductionNotes || "");
      formik.setFieldValue(
        "deductionFromClientInvoice",
        isFlagOn(data?.deductionFromClientInvoice),
      );
    }
  }, [data]);

  const getColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "white";
      // case "pending":
      //   return "#4D4D4D";
      // case "accepted":
      //   return "#02493E";
      // case "rejected":
      //   return "#371414";

      default:
        return "#02493E";
    }
  };

  const getTextColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "black";
      // case "pending":
      //   return "white";
      // case "accepted":
      //   return "#07EEC5";
      // case "rejected":
      //   return "#FF4B4B";

      default:
        return "#07EEC5";
    }
  };

  return (
    <>
      <Accordion
        sx={{
          borderRadius: "8px",
          backgroundColor: "transparent",
          width: "100%",
        }}
        expanded={expanded === `panel${index}`}
        onChange={handleAccChange(`panel${index}`)}
      >
        <AccordionSummary
          sx={{
            backgroundColor: "rgba(100, 100, 100, 0.4)",
            border: `1px solid ${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })}`,
            borderRadius: "8px",
            "& p": {
              fontSize: "1.2rem",
            },

            "@media(max-width: 600px)": {
              fontSize: "1rem",
            },
          }}
          expandIcon={<ExpandMore sx={{ color: "white" }} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            {values?.deductionCategoryType || ""}
          </Typography>
          <Typography sx={{ color: "white", WebkitLineClamp: 1, width: "43%" }}>
            {values?.deductionDate
              ? dayjs(values?.deductionDate).format("ddd MM-DD-YYYY") ||
                "Date of Deduction"
              : ""}
          </Typography>
          <Typography
            sx={{
              color: getTextColorOfStatus(status),
              border: `1px solid ${getColorOfStatus(status)}`,
              backgroundColor: getColorOfStatus(status),
              padding: "0.2rem",
              borderRadius: "8px",
              minWidth: "23%",
              textAlign: "center",
              height: "35px",
            }}
          >
            {data?._id ? "Deducted" : "Draft"}
          </Typography>
          {/* NOTE: only show the delete button when the data is saved  */}
          {data?._id &&
            isUserRole(
              USER_ROLES.SUPERADMIN,
              USER_ROLES.ADMIN,
              USER_ROLES.COORDINATOR,
            ) && (
              <CustomIconButton
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatch(
                    alertDialogAciton({
                      open: true,
                      title: "Warning",
                      message:
                        "Are you sure, you want to remove this deduction?",
                      okLabel: "Delete",
                      onOk: () => {
                        dispatch(
                          removeReimbursementOrDeductionAction({
                            payload: {
                              data: {
                                ids: [
                                  {
                                    id: data?._id,
                                  },
                                ],
                              },
                              additionalData: {
                                contractorId: data?.contractorDetails?._id,
                              },
                            },
                            successCallback: () => {
                              refreshList();
                            },
                          }),
                        );
                      },
                    }),
                  );
                }}
              >
                <Delete sx={{ fontSize: "1.5rem" }} />
              </CustomIconButton>
            )}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: "transparent",
            border: `1px solid ${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })}`,
            borderTop: "none",
            borderRadius: "8px",
            padding: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "1rem",
            flexDirection: "column",
            overflowY: "auto",
            maxHeight: "65%",
            "& p": {
              fontSize: "1.2rem",
            },
            "@media(max-width: 600px)": {
              fontSize: "1rem",
            },
          }}
          className="custom-scroll-design"
        >
          <Box
            sx={{
              padding: "1rem",
              width: "100%",
              display:
                data?._id || data?.positionDetails?._id || data?.positionId
                  ? "block"
                  : "none",
            }}
          >
            {data?._id && (
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                }}
              >
                Deduction ID: {data?._id || "N/A"}
              </Typography>
            )}
            {(data?.positionDetails?._id || data?.positionId) &&
            data?.reImbursementStatus == "draft" ? (
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                }}
              >
                Position: {data?.positionDetails?.name}
              </Typography>
            ) : null}
            {data?.positionId && data?.reImbursementStatus !== "draft" ? (
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                }}
              >
                Position: {data?.positionName}
                {data?.positionOrder ? `-${data?.positionOrder}` : ""} (
                {getUniversalDateTimeFormat({
                  dateTime: data?.positionStartDate,
                })}
                )
              </Typography>
            ) : null}
          </Box>

          {/* deduction date */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="date-select"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Date of Deduction*
              </Typography>
            </InputLabel>
            <Box
              sx={{
                width: "200px",
              }}
            >
              <CustomDatePicker
                variant="rounded"
                name="deductionDate"
                sx={{
                  "& fieldset": {
                    borderColor: `${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} !important`,
                    borderWidth: "1.8px",
                  },
                  "& input": {
                    paddingY: "1rem !important",
                  },
                }}
                labelId="date-select"
                value={
                  values?.deductionDate ? dayjs(values.deductionDate) : null
                }
                // format={values?.deductionDate ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                onBlur={handleBlur}
                readOnly={!isEditable}
                onChange={(date) => {
                  formik.setFieldValue(
                    "deductionDate",
                    date?.format("YYYY-MM-DD"),
                  );
                }}
              />
            </Box>
          </Box>
          {errors?.deductionDate && touched?.deductionDate && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.deductionDate}
            </Typography>
          )}

          {/* here */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
              gap: "0.25rem",
              paddingLeft: "1rem",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: "white",
                WebkitLineClamp: 1,
                width: "43%",
                fontWeight: "500",
              }}
            >
              Category
            </Typography>
            <Autocomplete
              fullWidth
              freeSolo
              readOnly={data?._id}
              options={
                deductionCategories?.filter(
                  (item) => item?.deductionCategoryType,
                ) || []
              }
              getOptionLabel={(option) => option?.deductionCategoryType}
              value={{
                deductionCategoryType: values?.deductionCategoryType || "",
              }}
              onInputChange={(_, newVal, reason) => {
                if (reason === "input") {
                  formik.setFieldValue("deductionCategoryType", newVal);
                }
              }}
              onChange={(_, newVal) => {
                formik.setFieldValue(
                  "deductionCategoryType",
                  newVal?.deductionCategoryType,
                );
              }}
              componentsProps={{
                paper: {
                  style: {
                    display: "block",
                    background: "black",
                    outline: "1px solid white",
                    borderRadius: "8px",
                  },
                },
              }}
              onBlur={handleBlur}
              noOptionsText={"No Categories Available"}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="deductionCategoryType"
                  placeholder="Type Here"
                  InputLabelProps={{
                    style: { color: "white" },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      paddingY: "7px !important",
                      "& fieldset": {
                        borderRadius: "8px",
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      "&:hover fieldset": {
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      color: "white",
                    },
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiAutocomplete-popupIndicator": {
                      color: "white",
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {option.deductionCategoryType}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(
                        alertDialogAciton({
                          open: true,
                          title: "Delete Category",
                          message:
                            "Are you sure you want to delete this category?",
                          onOk: () => {
                            dispatch(
                              removeReimbursementAndDeductionCategoriesAction({
                                payload: {
                                  params: {
                                    id: option?._id,
                                  },
                                },
                                successCallback: () => {
                                  dispatch(getDeductionCategoriesAction({}));
                                  dispatch(
                                    alertDialogAciton({
                                      open: true,
                                      title: "Success",
                                      message: "Category Deleted Successfully.",
                                    }),
                                  );
                                },
                                failureCallback: () => {
                                  dispatch(
                                    alertDialogAciton({
                                      open: true,
                                      title: "Error",
                                      message: "Failed to delete category.",
                                    }),
                                  );
                                },
                              }),
                            );
                          },
                          okLabel: "Delete",
                        }),
                      );
                    }}
                  >
                    <Delete sx={{ color: "white", fontSize: "1.5rem" }} />
                  </IconButton>
                </li>
              )}
            />
            {touched.categoryType && errors.categoryType && (
              <Typography color={"red"} fontSize={"0.75rem"}>
                {errors.categoryType}
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="amount-input"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                {/* Amount* */}
                Deduct Amount
              </Typography>
            </InputLabel>

            <Box
              sx={{
                position: "relative",
              }}
            >
              <CustomInput
                labelId="amount-input"
                className="rate-input"
                name="deductionAmount"
                sx={{
                  border: `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} `,
                  borderRadius: "8px",
                  fontSize: "16px",
                  width: "200px !important",
                  // "& fieldset": {
                  //   border: "none",
                  // },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: `${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} !important`,
                  },
                }}
                type="number"
                fullWidth
                placeholder="00.00"
                onChange={handleChange}
                readOnly={!isEditable}
                onBlur={handleBlur}
                value={values?.deductionAmount}
                startAdornment={
                  <InputAdornment position="start">
                    <Typography variant="h5" color="primary">
                      &#36;
                    </Typography>
                  </InputAdornment>
                }
              />
            </Box>
          </Box>
          {errors?.deductionAmount && touched?.deductionAmount && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.deductionAmount}
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "0.5rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="deductionNotes-input"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Notes
              </Typography>
            </InputLabel>
            <TextField
              name="deductionNotes"
              multiline
              maxRows={2}
              rows={2}
              sx={{
                width: "100%",
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} !important`,
                },
                "& input, fieldset, textarea": {
                  color: "white",
                  fontSize: "16px",
                },
              }}
              onChange={handleChange}
              InputProps={{
                readOnly: !isEditable,
              }}
              onBlur={handleBlur}
              value={values?.deductionNotes}
              placeholder="Add Notes here"
            />
          </Box>
          {errors?.deductionNotes && touched?.deductionNotes && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.deductionNotes}
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "1rem",
              paddingX: "1rem",
            }}
          >
            <Checkbox
              checked={values?.deductionFromClientInvoice}
              readOnly={data?._id}
              onChange={(e) => {
                if (data?._id) return;
                formik.setFieldValue(
                  "deductionFromClientInvoice",
                  e.target?.checked,
                );
              }}
              sx={{
                padding: "0 !important",
                color: "white",
              }}
            />
            <Typography>Add this in client invoice</Typography>
          </Box>
          {data?.reImbursementStatus == "draft" && user == "admin" ? (
            data?.positionDetails?._id && data?.contractorDetails?._id ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    // gap: "1rem",
                    paddingX: 2,
                  }}
                >
                  <Typography sx={{ fontWeight: "500" }}>
                    Deduction Linked To
                  </Typography>
                  <FormControl
                    sx={{
                      width: "100%",
                    }}
                  >
                    <RadioGroup
                      name="isLinkToContractor"
                      row
                      sx={{ flexWrap: "wrap" }}
                      onChange={(e) => {
                        const value = e?.target?.value;
                        if (value == 0) {
                          formik?.setFieldValue("isLinkToContractor", true);
                        } else {
                          formik?.setFieldValue("isLinkToContractor", false);
                        }
                      }} // your handler
                      value={values?.isLinkToContractor ? 0 : 1}
                    >
                      <FormControlLabel
                        value="0"
                        control={
                          <Radio
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                              "&.Mui-checked": {
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                              },
                            }}
                          />
                        }
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                            }}
                          >
                            Contractor
                            {/* NOTE: update the info icon with black i and white bg */}
                            <InfoHover
                              title=" This deduction is linked directly to the contractor. "
                              infoStyles={{
                                color: getCssVariableHandler({
                                  variableName: "--white-rgb",
                                }),
                              }}
                              isBgFilled
                            />
                          </Box>
                        }
                      />
                      <FormControlLabel
                        value="1"
                        control={
                          <Radio
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                              "&.Mui-checked": {
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                              },
                            }}
                          />
                        }
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                            }}
                          >
                            Position
                            <InfoHover
                              title=" This deduction is linked to a position. If the contractor assigned to this position changes, the reimbursement will automatically transfer to the new contractor. "
                              infoStyles={{
                                color: getCssVariableHandler({
                                  variableName: "--white-rgb",
                                }),
                              }}
                              isBgFilled
                            />
                          </Box>
                        }
                      />
                    </RadioGroup>
                  </FormControl>

                  {errors?.isLinkToContractor &&
                    touched?.isLinkToContractor && (
                      <Typography
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                        color="error"
                      >
                        {errors?.isLinkToContractor}
                      </Typography>
                    )}
                </Box>
              </>
            ) : null
          ) : null}

          {data?.reImbursementStatus !== "draft" ||
          (data?.reImbursementStatus == "draft" && !isBothPosAndConPresent) ? (
            ((data?.positionDetails?._id || data?.positionId) &&
              data?.reImbursementStatus == "draft") ||
            (data?.reImbursementStatus !== "draft" &&
              data?.isReimbursementAttachedToPosition) ? (
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1rem !important",
                  fontWeight: "300",
                  width: "100%",
                  color: getCssVariableHandler({
                    variableName: "--primary-green-text-hex",
                  }),
                }}
              >
                This deduction is linked to a position. If the contractor
                assigned to this position changes, the reimbursement will
                automatically transfer to the new contractor.
              </Typography>
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1rem !important",
                  fontWeight: "300",
                  width: "100%",
                  color: getCssVariableHandler({
                    variableName: "--primary-green-text-hex",
                  }),
                }}
              >
                This deduction is linked directly to the contractor.
              </Typography>
            )
          ) : null}

          {/* NOTE: buttons for request deduction */}
          <Box
            className="bottomButton"
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
              width: "100%",
              gap: "3rem",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            {user === "contractor" && isEditable && (
              <Button
                className="btnPink"
                sx={{
                  width: "auto !important",
                }}
                onClick={() => {
                  submitForm();
                }}
              >
                <Typography
                  sx={{
                    textWrap: "nowrap",
                  }}
                  classname="btn-text"
                >
                  Request deduction
                </Typography>
              </Button>
            )}
            {user == "admin" &&
              data?.reImbursementStatus?.toLowerCase() == "draft" && (
                <Button className="btnPink" onClick={submitForm}>
                  {arLoading ? (
                    <CircularProgress />
                  ) : (
                    <Typography className="btn-text">Add deduction</Typography>
                  )}
                </Button>
              )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

DeductionAcc.propTypes = {
  user: PropTypes.string,
  data: PropTypes.object,
  expanded: PropTypes.string,
  handleAccChange: PropTypes.func,
  sessionId: PropTypes.string,
  id: PropTypes.string,
  setData: PropTypes.func,
  isEditable: PropTypes.bool,
  status: PropTypes.string,
  index: PropTypes.number,
  fetchPO: PropTypes.func,
};